// Page Blog Desktop - Wrapper pour le composant mobile
import MobileBlogPage from '../mobile/MobileBlogPage';

export default function DesktopBlogPage({ embedded = false }) {
  if (embedded) {
    return <MobileBlogPage isDesktopEmbed={true} />;
  }
  
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden my-6">
          <MobileBlogPage isDesktopEmbed={true} />
        </div>
      </div>
    </div>
  );
}
